import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'

import libs from './libs/libs'
import api from './libs/api'

import { ImagePreview } from 'vant';
import { Lazyload } from 'vant';
import { Image as VanImage } from 'vant';
import { Loading } from 'vant';

Vue.use(Loading);
Vue.use(VanImage);
Vue.use(Lazyload);
// 全局注册
Vue.use(ImagePreview);
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: 'GoB97lWBQ4DgvqQQZyFSeixBK2uNdTTF'
})

Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.prototype.libs = libs
Vue.prototype.api = api

Vue.prototype.formatTime = function(time, cFormat) {
    if (arguments.length === 0) return null
    if ((time + '').length === 10) {
        time = +time * 1000
    }

    var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}', date
    if (typeof time === 'object') {
        date = time
    } else {
        date = new Date(time)
    }

    var formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        var value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

var vue = new Vue({
    router,
    store,
    render: h => h(App),
    created(){
        // px2rem
        (function (doc, win) {
            var domWidth = 750;
            var docEl = doc.documentElement,
                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                recalc = function () {
                    var clientWidth = docEl.clientWidth;
                    if (!clientWidth) return;
                    docEl.style.fontSize = 100 * (clientWidth / domWidth) + 'px';
                };
            recalc();
            if (!doc.addEventListener) return;
            win.addEventListener(resizeEvt, recalc, false);
        })(document, window);
    }
}).$mount('#app')
